// The Supabase client, as the signed-in user. The publishable key is public by design; row-level
// security keeps each account's rows to itself, and writes need an active subscription.

import { createClient } from "@supabase/supabase-js";

// Development falls back to the local stack; a build without the hosted project's settings fails
// here instead of quietly talking to 127.0.0.1.
const localStack = import.meta.env.DEV
  ? { url: "http://127.0.0.1:54321", key: "sb_publishable_ACJWlzQHlZjBrEguHvfOxg_3BJgxAaH" }
  : undefined;

export const supabaseURL: string = import.meta.env.VITE_SUPABASE_URL || localStack?.url || missing("VITE_SUPABASE_URL");
const publishableKey: string = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || localStack?.key || missing("VITE_SUPABASE_PUBLISHABLE_KEY");

function missing(name: string): never {
  throw new Error(`${name} isn't set for this build. See web/README.md.`);
}

export const supabase = createClient(supabaseURL, publishableKey, {
  auth: {
    flowType: "pkce",
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

/** A short-lived MapKit JS token; without one, maps draw the route on a plain backdrop. */
export const mapKitToken: string | undefined = import.meta.env.VITE_MAPKIT_TOKEN || undefined;
